/* eslint-disable */
import React, { Component } from "react";
import { validated } from "react-custom-validation";
import validator from "validator";
import axios from "axios";

import { appId, apiUrl } from "../Helpers/Config";

const isEmpty = (value) => (value === "" ? "This field is required." : null);

const isEmail = (email) =>
  validator.isEmail(email) ? null : "This is not a valid email.";

const phonenumberPattern = /^[0-9]{6,8}$/;
const isMobile = (mobile) =>
  mobile.match(phonenumberPattern) ? null : "please enter valid Phone number.";
const isChecked = (terms) =>
  terms ? null : "Please accept terms and conditions";
function validationConfigCheckout(props) {
  const {
    check_firstname,
    check_lastname,
    check_email,
    check_phone,
    terms,
    pdpa_consent,
  } = props.fields;
  return {
    fields: [
      "firstname",
      "lastname",
      "email",
      "mobile",
      "terms",
      "pdpa_consent",
    ],

    validations: {
      firstname: [[isEmpty, check_firstname]],
      lastname: [[isEmpty, check_lastname]],
      email: [[isEmail, check_email]],
      mobile: [
        [isEmpty, check_phone],
        [isMobile, check_phone],
      ],
      terms: [[isChecked, terms, 1]],
    },
  };
}

class Guestcheckout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: "Loading",
      check_phone: "",
    };
  }

  componentDidMount() {
    var check_phone = this.props.fields.check_phone;
    this.setState({ check_phone: check_phone });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ check_phone: nextProps.fields.check_phone });
  }

  isGuestPhonenumerExist() {
    var mobile = $("#check_phone").val();
    this.setState({ check_phone: mobile });
    this.props.onChange("check_phone", mobile);
    if (mobile.length > 7) {
      axios
        .get(
          apiUrl +
            "guestaccount/guest_customer_phone?app_id=" +
            appId +
            "&status=A&phone_no=" +
            mobile
        )
        .then((response) => {
          if (response.data.status === "ok") {
            this.props.onChange("check_phone", mobile);
            this.props.onChange(
              "check_firstname",
              response.data.result_set.customer_first_name
            );
            this.props.onChange(
              "check_lastname",
              response.data.result_set.customer_last_name
            );
            this.props.onChange(
              "check_email",
              response.data.result_set.customer_email
            );
          } else {
            this.props.onChange("check_phone", mobile);
            /*this.props.onChange('check_firstname', '');
                    this.props.onChange('check_lastname', '');
                    this.props.onChange('check_email', ''); */
          }
        });
    } else {
      this.setState({ check_phone: mobile });
    }
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } =
      this.props;

    let errMsgFirstName, errMsgLastName, errMsgEmail, errMsgMobile, errMsgTerms;

    if ($validation.firstname.error.reason !== undefined) {
      errMsgFirstName = $validation.firstname.show && (
        <span className="error">{$validation.firstname.error.reason}</span>
      );
    }

    if ($validation.lastname.error.reason !== undefined) {
      errMsgLastName = $validation.lastname.show && (
        <span className="error">{$validation.lastname.error.reason}</span>
      );
    }
    if ($validation.email.error.reason !== undefined) {
      errMsgEmail = $validation.email.show && (
        <span className="error">{$validation.email.error.reason}</span>
      );
    }
    if ($validation.mobile.error.reason !== undefined) {
      errMsgMobile = $validation.mobile.show && (
        <span className="error">{$validation.mobile.error.reason}</span>
      );
    }
    if ($validation.terms.error.reason !== undefined) {
      errMsgTerms = $validation.terms.show && (
        <span className="error">{$validation.terms.error.reason}</span>
      );
    }

    return (
      <div className="popup-body">
        <span className="guest-chk-error"></span>
        <h4>Guest Checkout Details</h4>
        <div className="form-group">
          <div className="focus-out">
            <label>Phone number</label>
            <input
              type="tel"
              maxLength="8"
              id="check_phone"
              className="form-control input-focus"
              pattern="\d*"
              value={this.state.check_phone}
              onChange={() => this.isGuestPhonenumerExist()}
            />
            <div id="spn-mobile-error">{errMsgMobile}</div>
          </div>
        </div>
        <div className="form-group">
          <div
            className={
              fields.check_firstname != "" ? "focus-out focused" : "focus-out"
            }
          >
            <label>First Name</label>
            <input
              type="text"
              className="form-control input-focus"
              value={fields.check_firstname}
              {...$field("check_firstname", (e) =>
                onChange("check_firstname", e.target.value)
              )}
            />
            {errMsgFirstName}
          </div>
        </div>
        <div className="form-group">
          <div
            className={
              fields.check_lastname != "" ? "focus-out focused" : "focus-out"
            }
          >
            <label>Last Name</label>
            <input
              type="text"
              className="form-control input-focus"
              value={fields.check_lastname}
              {...$field("check_lastname", (e) =>
                onChange("check_lastname", e.target.value)
              )}
            />
            {errMsgLastName}
          </div>
        </div>

        <div className="form-group">
          <div
            className={
              fields.check_email != "" ? "focus-out focused" : "focus-out"
            }
          >
            <label>Email</label>
            <input
              type="text"
              className="form-control input-focus"
              value={fields.check_email}
              {...$field("check_email", (e) =>
                onChange("check_email", e.target.value)
              )}
            />
            <div id="spn-email-error">{errMsgEmail}</div>
          </div>
        </div>
        <div className="form-group">
          <div className="custom_checkbox custom_checkbox_content">
            <input
              type="checkbox"
              id="terms"
              checked={fields.terms}
              {...$field(
                "terms",
                (e) => onChange("terms", e.target.value),
                null,
                false
              )}
            />{" "}
            <span></span>
            <div className="sign_reg">
              <p>
                Yes, I have read and agree to the Canadian 2 For 1 Pizza &nbsp;
                <a
                  className="sign_reg_uline"
                  href="/terms-and-conditions"
                  target="_blank"
                >
                  Terms &amp; Conditions.
                </a>
              </p>
            </div>
          </div>
          {errMsgTerms}
        </div>
        <div className="form-group">
          <div className="custom_checkbox custom_checkbox_content">
            <input
              type="checkbox"
              id="pdpa_consent"
              checked={fields.pdpa_consent}
              {...$field(
                "pdpa_consent",
                (e) => onChange("pdpa_consent", e.target.value),
                null,
                false
              )}
            />{" "}
            <span></span>
            <div className="sign_reg">
              <p>
                Yes, I would like to receive latest promotions and offers via
                SMS / Email from Canadian 2 For 1 Pizza
              </p>
            </div>
          </div>
        </div>
        <div className="form-group">
          <div className="login_pop_sub login_in_guest">
            <button
              type="button"
              className="btn btn_black btn_minwid guestcheckout_submit"
              onClick={(e) => {
                e.preventDefault();
                this.props.$submit(onValid, onInvalid);
              }}
            >
              Submit
            </button>
          </div>
        </div>
        <div className="form-group">
          <div className="controls single-link">
            <a href="#login-popup" className="open-popup-link">
              Back to login
            </a>
          </div>
        </div>
      </div>
    );
  }
}
Guestcheckout = validated(validationConfigCheckout)(Guestcheckout);

export default Guestcheckout;
